module.exports = __webpack_public_path__ + "static/mk8-c6cd359e0e80499b89229dc298c84e98.png";